var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.714 13.5359L11.1785 10.0004L14.714 6.46482C14.8703 6.30854 14.9581 6.09658 14.9581 5.87557C14.9581 5.65455 14.8703 5.44259 14.714 5.28631C14.5578 5.13003 14.3458 5.04223 14.1248 5.04223C13.9038 5.04223 13.6918 5.13003 13.5355 5.28631L10 8.82184L6.46447 5.28631C6.30819 5.13003 6.09622 5.04223 5.87521 5.04223C5.6542 5.04223 5.44224 5.13003 5.28595 5.28631C5.12967 5.44259 5.04188 5.65455 5.04188 5.87557C5.04188 6.09658 5.12967 6.30854 5.28595 6.46482L8.82149 10.0004L5.28595 13.5359C5.12967 13.6922 5.04188 13.9041 5.04188 14.1251C5.04188 14.3462 5.12967 14.5581 5.28595 14.7144C5.44224 14.8707 5.6542 14.9585 5.87521 14.9585C6.09622 14.9585 6.30819 14.8707 6.46447 14.7144L10 11.1789L13.5355 14.7144C13.6918 14.8707 13.9038 14.9585 14.1248 14.9585C14.3458 14.9585 14.5578 14.8707 14.714 14.7144C14.8703 14.5581 14.9581 14.3462 14.9581 14.1251C14.9581 13.9041 14.8703 13.6922 14.714 13.5359Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModel);
export default __webpack_public_path__ + "static/media/closeModel.34cd55196f1e3cc37c92270745b4c352.svg";
export { ForwardRef as ReactComponent };